import { defineComponent as _defineComponent } from 'vue'
import AddToCartError from './AddToCartError.vue';
import UiButton from 'JS/components/UiButton.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'CannotAddToCart',
  setup(__props) {


return { __sfc: true,AddToCartError, UiButton }
}

})